/**
 * Reloj de las pantallas de asambleas: la hora actual que se renueva sola en
 * los bordes de una ventana (T-15, el inicio, el cierre de la sala…), sin
 * consultar al servidor. Lo usan la tarjeta del propietario y la página
 * pública de la asamblea.
 */
import { useEffect, useState } from "react";
import { msHastaProximo } from "./api";

// setTimeout no acepta esperas más largas que esto (unos 24,8 días).
const MAX_TIMEOUT_MS = 2147483647;

/**
 * Hora actual (ms) que se vuelve a leer en el próximo de los `limites` (ms;
 * los que no son números se ignoran). Si un límite ya pasó sin reflejarse (la
 * compu se durmió, el timer se atrasó), se pone al día enseguida.
 */
export function useAhoraEnLimites(limites) {
  const [ahora, setAhora] = useState(() => Date.now());
  const clave = (limites || []).filter((l) => Number.isFinite(l)).join(",");
  useEffect(() => {
    const lista = clave ? clave.split(",").map(Number) : [];
    const ya = Date.now();
    if (lista.some((l) => l > ahora && l <= ya)) {
      setAhora(ya);
      return undefined;
    }
    const espera = msHastaProximo(lista, ya);
    if (espera == null) return undefined;
    const t = setTimeout(() => setAhora(Date.now()), Math.min(espera + 50, MAX_TIMEOUT_MS));
    return () => clearTimeout(t);
  }, [clave, ahora]);
  return ahora;
}
